import { render, staticRenderFns } from "./PaymentsDebitView.vue?vue&type=template&id=2dd847b2"
import script from "./PaymentsDebitView.vue?vue&type=script&lang=js"
export * from "./PaymentsDebitView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports